import { render, staticRenderFns } from "./AssignLeadsDialog.vue?vue&type=template&id=5e1c749f&"
import script from "./AssignLeadsDialog.vue?vue&type=script&lang=js&"
export * from "./AssignLeadsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports